export default "__VITE_ASSET__CkMetouP__"